import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  q: '¿Es un producto físico?',
  a: 'No, es 100% digital. Recibís archivos PDF listos para descargar e imprimir desde casa inmediatamente después de tu compra.'
}, {
  q: '¿Lo recibo al instante?',
  a: '¡Sí! Inmediatamente después de procesar tu pago, recibís un correo electrónico con el enlace de acceso a toda la biblioteca.'
}, {
  q: '¿Cuántas veces puedo imprimir?',
  a: 'Las veces que quieras, sin ningún límite. Si una hoja se rompe o quieren volver a pintarla, simplemente la imprimís de nuevo.'
}, {
  q: '¿Necesito una impresora especial?',
  a: 'No, cualquier impresora doméstica funciona perfectamente. Los archivos están optimizados para tamaño A4/carta estándar.'
}, {
  q: '¿Funciona con cualquier impresora?',
  a: 'Sí, podés imprimir en blanco y negro (recomendado para colorear) o a color. Funciona en impresoras de tinta o láser.'
}, {
  q: '¿Cómo accedo al contenido?',
  a: 'Recibís un enlace seguro por email. Podés descargar los libros a tu computadora, tablet o celular y tenerlos guardados para siempre.'
}, {
  q: '¿Puedo imprimir solamente los personajes que le gustan a mi hijo?',
  a: '¡Por supuesto! Los libros están organizados por personaje y franquicia. Imprimís solo lo que quieras, cuando quieras.'
}, {
  q: '¿Puedo usarlo con varios hijos?',
  a: 'Sí, una sola compra te da acceso ilimitado. Podés imprimir copias para todos tus hijos, sobrinos o amigos sin restricciones.'
}];
export const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-8 px-4 bg-cream" data-id="element-62">
      <div className="max-w-2xl mx-auto" data-id="element-63">
        <p className="text-center font-rounded font-bold text-textsoft uppercase text-xs tracking-widest mb-2" data-id="element-64">
          Resuelve tus dudas
        </p>
        <h2 className="font-rounded font-bold text-[2rem] sm:text-4xl text-violet text-center leading-tight mb-8" data-id="element-65">
          Preguntas <span className="text-gold-dark" data-id="element-66">frecuentes</span>
        </h2>

        <div className="space-y-2.5" data-id="element-67">
          {faqs.map((faq, idx) => {
          const isOpen = openIndex === idx;
          return <div key={idx} className={`bg-white rounded-2xl overflow-hidden border-2 transition-colors ${isOpen ? 'border-gold' : 'border-cream-dark'}`} data-id="element-68">
                <button onClick={() => setOpenIndex(isOpen ? null : idx)} className="w-full px-5 py-4 text-left flex justify-between items-center focus:outline-none gap-3" data-id="element-69">
                  <span className="font-rounded font-bold text-violet text-sm sm:text-base leading-tight" data-id="element-70">
                    {faq.q}
                  </span>
                  <div className={`flex-shrink-0 rounded-full w-7 h-7 flex items-center justify-center transition-colors ${isOpen ? 'bg-gold-dark text-violet' : 'bg-cream-dark text-violet'}`} data-id="element-71">
                    {isOpen ? <Minus size={16} strokeWidth={3.5} data-id="element-72" /> : <Plus size={16} strokeWidth={3.5} data-id="element-73" />}
                  </div>
                </button>

                <AnimatePresence data-id="element-74">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} data-id="element-75">
                      <div className="px-5 pb-4 text-textsoft text-sm sm:text-base leading-relaxed font-semibold" data-id="element-76">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
};